import React, {useState, useCallback} from 'react';

import {observer} from 'mobx-react';
import {IconButton} from '@mui/material';
import Fade from '@mui/material/Fade';
import PublishIcon from '@mui/icons-material/Publish';
import DeleteIcon from '@mui/icons-material/Delete';

import {useStores} from '../../../Hooks';
import ConditionalComponent from '../../Shared/ConditionalComponent';
import Utility from '../../../Utility';

const rowClass = 'flex items-center justify-between py-1';
const textClass = 'text-xs text-main-normal';

const openCropperForUpload = (modalStore, logoId, onUpdateLogo) => async (files) => {
    const file = files[0];
    const dataURL = await Utility.readDataFromUrl(file.FileId);
    const fileName = `${file.FileName}.${file.FileExtension}`;
    modalStore.modalData = {
        currentlyCroppedImage: dataURL,
        fileFullName: fileName,
        oldFileId: logoId,
        aspectRatio: 1,
        saveMethod: async (newImageId) => onUpdateLogo(newImageId),
    };
    modalStore.isCropperModalOpen = true;
};

const LogoHoverActions = ({isVisible, onReplace, onDelete}) => (
    <Fade in={isVisible}>
        <div className="absolute inset-0 flex items-center justify-center gap-1 bg-white/80 rounded-lg">
            <IconButton size="small" onClick={onReplace}>
                <PublishIcon fontSize="small" htmlColor="#2F80ED" />
            </IconButton>
            <IconButton size="small" onClick={onDelete}>
                <DeleteIcon fontSize="small" color="error" />
            </IconButton>
        </div>
    </Fade>
);

const ThreeDLogoSection = observer(({logoId, onUpdateLogo, t}) => {
    const {modalStore} = useStores();
    const [isHovered, setIsHovered] = useState(false);

    const selectLogo = useCallback(() => {
        modalStore.modalData = {
            ...modalStore.modalData,
            onMediaSelected: openCropperForUpload(modalStore, logoId, onUpdateLogo),
            onlyImages: true,
        };
        modalStore.isMediaLibraryModalOpen = true;
    }, [modalStore, logoId, onUpdateLogo]);

    return (
        <div className={rowClass}>
            <span className={textClass}>{'3D ' + t('menuCompanyLogo')}</span>
            <div
                className="relative w-12 h-12 rounded-lg border border-panels-normal flex items-center justify-center"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <ConditionalComponent if={!!logoId}>
                    <img className="w-full h-full object-contain rounded-lg" src={logoId} alt="3D logo" />
                </ConditionalComponent>
                <ConditionalComponent if={!logoId}>
                    <IconButton onClick={selectLogo} size="small">
                        <PublishIcon htmlColor="#93989f" />
                    </IconButton>
                </ConditionalComponent>
                <LogoHoverActions isVisible={isHovered && !!logoId} onReplace={selectLogo} onDelete={() => onUpdateLogo('')} />
            </div>
        </div>
    );
});

export default ThreeDLogoSection;
